<script>
export default {
  name: 'paginated filtered list mixin',
  beforeMount: function () {
    // Load filters and page from URL query string
    Object.keys(this.$route['query']).forEach(key => {
      if (this.filters[key] !== undefined) {
        if (Array.isArray(this.filters[key]) && typeof this.$route['query'][key] === 'string') {
          this.filters[key] = [this.$route['query'][key]]
        } else {
          this.filters[key] = this.$route['query'][key]
        }
      }
      if (key === 'page') {
        this.page = parseInt(this.$route['query']['page'])
      }
    })
  },
  methods: {
    setURLQueryParams (config) {
      Object.keys(config).forEach(key => { if (!config[key]) { delete config[key] } })
      this.$router.replace({ name: this.$route.name, query: config }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },
    resetFilters () {
      this.loadingList = true
      var datePickerFields = []
      Object.keys(this.filters).forEach(key => {
        if (Array.isArray(this.filters[key])) {
          this.filters[key] = []
        } else if (this.isDatePickerField(key) &&
        !(this.getDatePickerFieldName(key) in datePickerFields)) {
          datePickerFields.push(this.getDatePickerFieldName(key))
        } else {
          this.filters[key] = null
        }
      })
      datePickerFields.forEach(key => {
        this.$refs[key].clear()
      })
      this.loadingList = false
    },
    applyFilters () {
      this.getPage(1)
    },
    isDatePickerField (filterKey) {
      return !isNaN(filterKey.slice(-1))
    },
    getDatePickerFieldName (filterKey) {
      return filterKey.slice(0, filterKey.length - 2)
    },
    getPage (page) {
      if (this.loadingList) { return }
      this.loadingList = true
      this.page = page
      var filters = {}
      Object.keys(this.filters).forEach((key) => {
        filters[key] = this.filters[key] && this.filters[key].id ? this.filters[key].id : this.filters[key]
      })
      var config = Object.assign(filters, {page: this.page})
      this.setURLQueryParams(config)
      return this.getObjects(config).then(
        response => {
          this.objects = response
          this.loadingList = false
        }
      )
    }
  },
  data () {
    return {
      page: 1,
      filters: {},
      loadingList: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mixins/PaginatedFilteredListMixin.vue